import { getDeployOptions } from './environment';

/**
 * Application configuration wrapper
 */
export default class Config {
  /**
   * Return stripe key
   */
  public static get stripeKey(): string {
    const OPTIONS = getDeployOptions();
    return OPTIONS.stripeKey;
  }

  public static get stripePk(): string {
    const OPTIONS = getDeployOptions();
    return OPTIONS.stripePk;
  }

  public static get quickbookClientId(): string {
    const OPTIONS = getDeployOptions();
    return OPTIONS.quickbookClientId;
  }

  public static get quickbookRedirectUri(): string {
    const OPTIONS = getDeployOptions();
    return OPTIONS.quickbookRedirectUri;
  }

  public static get fileStoreUrl(): string {
    const OPTIONS = getDeployOptions();
    return OPTIONS.fileStoreUrl;
  }

  public static get lambdaApiUrl(): string {
    const OPTIONS = getDeployOptions();
    return OPTIONS.lambdaApiUrl;
  }

  public static get lambdaApiKey(): string {
    const OPTIONS = getDeployOptions();
    return OPTIONS.lambdaApiKey;
  }

  public static get pricingTableId(): string {
    const OPTIONS = getDeployOptions();
    return OPTIONS.pricingTableId;
  }

  public static get mixpanel(): string {
    const OPTIONS = getDeployOptions();
    return OPTIONS.mixpanel;
  }

  public static get productFruitsWorkspace(): string {
    const OPTIONS = getDeployOptions();
    return OPTIONS.productFruitsWorkspace;
  }

  public static get statsig(): string {
    const OPTIONS = getDeployOptions();
    return OPTIONS.statsig;
  }

  public static get stripeBuyMoreOrdersPk(): string {
    const OPTIONS = getDeployOptions();
    return OPTIONS.stripeBuyMoreOrdersPk;
  }

  public static get pricingTableBuyMoreOrdersId(): string {
    const OPTIONS = getDeployOptions();
    return OPTIONS.pricingTableBuyMoreOrdersId;
  }

  public static get pricingTablePlansId(): string {
    const OPTIONS = getDeployOptions();
    return OPTIONS.pricingTablePlansId;
  }

  public static get pricingTableSeatsId(): string {
    const OPTIONS = getDeployOptions();
    return OPTIONS.pricingTableSeatsId;
  }

  public static get n8nWebhookUrl(): string {
    const OPTIONS = getDeployOptions();
    return OPTIONS.n8nWebhookUrl;
  }
}
